import React from 'react';

const ErrorIcon = () => {

  return (
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22.5" cy="22.5" r="21.5" fill="white" stroke="black" strokeWidth="2" />
      <rect x="29.8672" y="13.3779" width="2.78297" height="23.854" transform="rotate(45 29.8672 13.3779)" fill="#A50034" />
      <rect x="13.1689" y="14.9678" width="2.78297" height="23.854" transform="rotate(-45 13.1689 14.9678)" fill="#A50034" />
    </svg>
  );

};


export default ErrorIcon;
